import { RecentChange } from "../Types/LastestChanges.interface";

async function GetRecentChanges(): Promise<RecentChange[]> {
    try {
        const annee = new Date().getFullYear();
        const response = await fetch(`http://openlibrary.org/recentchanges/${annee}.json?limit=15`);

        if (!response.ok) {
            throw new Error('Ressource non trouvée');
        }

        const changeList: RecentChange[] = await response.json();
        return changeList;

    } catch (error) {
        throw error;
    }
}

export { GetRecentChanges };
